import {
  apiRegister
} from '../../common/api';
import {
  map, isArray
} from '../../common/utils';
import {
  ERR_REP_ADDRESS_LIST
} from '../../common/const';

/*
协议Id 
903
项目 
模块 
方式 
https 
命令（路径） 
/bbs/district/
说明
地址，不用关心使用对象
请求参数
参数名称	参数类型	说明
id	int	可传可不传(不传取得是一二级的地址)

*/

const bbsDistrict = apiRegister('bbs-district', {
  protoId: 903,
  host: 'vip',
  path: '/bbs/district/',
  checkResult({addressList}) {
    if (!isArray(addressList)) {
      return ERR_REP_ADDRESS_LIST; // 数据格式非法
    }
    return 0;
  },
  formatResult(R) {
    const {
      addressList
    } = R

    const list = map(addressList, a => {
      const [id, level, name, type, pid, oid] = a
      return {id, level, name, type, pid, oid}
    })
    return {
      addressList,
      list
    }
  }
})

export const bbsDistrictLoad = bbsDistrict.send
